import accessLocalStorage from '../accessLocalStorage';

export const analyticsHeaders = async () => {
  const { token, user } = await accessLocalStorage.getUserLocalStorage();
  const tenantId = user && user.idtenant !== undefined ? String(user.idtenant) : '';
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(tenantId ? { 'x-tenant-id': tenantId } : {}),
  };
};
